<template>
  <div>
    <c-card title="작업환경측정결과 엑셀업로드" class="cardClassDetailForm">
      <template slot="card-button">
        <q-btn-group outline>
          <c-btn
            v-if="editable"
            label="LBLAPPLY"
            icon="save"
            @btnClicked="acceptData"
          />
        </q-btn-group>
      </template>
      <template slot="card-detail">
        <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6">
          <c-text
            :editable="editable"
            :disabled="true"
            label="요청부서/이름/일자"
            name="request"
            v-model="request"
          >
          </c-text>
        </div>
      </template>
    </c-card>
    <c-excel-upload :editable="editable" :excelUploadInfo="excelUploadInfo" />
  </div>
</template>

<script>
export default {
  name: "work-measure-result-excel-upload",
  props: {
    popupParam: {
      type: Object,
      default: function () {
        return {
          requestContents: "",
          hazardClassFstCd: "",
          plantCd: "",
        };
      },
    },
  },
  data() {
    return {
      excelUploadInfo: {
        rowKeys: ["workMeasurementResultId"], // 데이터들의 키 속성값
        taskClassCd: "WMR_RESULT", // 엑셀업로드 양식 구분 값
        sheetNum: 0,
        columns: [
          [
            {
              name: "",
              field: "",
              label: "",
              align: "left",
              sortable: true,
            },
            {
              name: "sortOrder",
              field: "sortOrder",
              label: "No.",
              align: "left",
              style: "width:80px",
              sortable: true,
            },
            {
              name: "deptCd",
              field: "deptCd",
              label: "부서명",
              align: "left",
              style: "width:100px",
              sortable: true,
            },
            {
              name: "process",
              field: "process",
              label: "공정코드",
              align: "left",
              style: "width:100px",
              sortable: true,
            },
            {
              name: "processCd",
              field: "processCd",
              label: "공정명",
              align: "left",
              style: "width:200px",
              sortable: true,
            },
            {
              required: true,
              name: "workPlace",
              field: "workPlace",
              label: "단위작업장소",
              align: "left",
              style: "width:150px",
            },
            {
              name: "hazardCd",
              field: "hazardCd",
              label: "유해인자코드",
              style: "width:100px",
              align: "left",
              sortable: true,
            },
            {
              name: "hazardName",
              field: "hazardName",
              label: "유해인자명",
              style: "width:100px",
              align: "left",
              type: "harmFulFactor",
              sortable: true,
            },
            {
              name: "workCount",
              field: "workCount",
              label: "근로자수",
              style: "width:100px",
              align: "right",
              sortable: true,
            },
            {
              name: "shiftType",
              field: "shiftType",
              label: "근로형태",
              style: "width:250px",
              align: "left",
              sortable: true,
            },
            {
              name: "occurTime",
              field: "occurTime",
              label: "발생시간",
              style: "width:100px",
              align: "center",
              sortable: true,
            },
            {
              name: "measPositionName",
              field: "measPositionName",
              label: "측정위치",
              style: "width:100px",
              align: "left",
              sortable: true,
            },
            {
              name: "workerName",
              field: "workerName",
              label: "근로자명",
              style: "width:100px",
              align: "center",
              sortable: true,
            },
            {
              name: "measStartTime",
              field: "measStartTime",
              label: "시작시간",
              style: "width:100px",
              align: "center",
              sortable: true,
            },
            {
              name: "measEndTime",
              field: "measEndTime",
              label: "종료시간",
              style: "width:100px",
              align: "center",
              sortable: true,
            },
            {
              name: "captureTime",
              field: "captureTime",
              label: "포집시간",
              style: "width:100px",
              align: "center",
              sortable: true,
            },
            {
              name: "measCount",
              field: "measCount",
              label: "측정횟수",
              style: "width:100px",
              align: "center",
              sortable: true,
            },
            {
              name: "measValueEtc",
              field: "measValueEtc",
              label: "측정치기타",
              style: "width:200px",
              align: "left",
              sortable: true,
            },
            {
              name: "measValue",
              field: "measValue",
              label: "측정치",
              style: "width:200px",
              align: "right",
              sortable: true,
            },
            {
              name: "twaPrevEtc",
              field: "twaPrevEtc",
              label: "전회기타",
              style: "width:200px",
              align: "left",
              sortable: true,
            },
            {
              name: "twaPrev",
              field: "twaPrev",
              label: "전회",
              style: "width:200px",
              align: "right",
              sortable: true,
            },
            {
              name: "twaCurrEtc",
              field: "twaCurrEtc",
              label: "금회기타",
              style: "width:200px",
              align: "left",
              sortable: true,
            },
            {
              name: "twaCurr",
              field: "twaCurr",
              label: "금회",
              style: "width:200px",
              align: "right",
              sortable: true,
            },
            {
              name: "afterExposureStandard",
              field: "afterExposureStandard",
              label: "보정후 노출기준",
              style: "width:100px",
              align: "right",
              sortable: true,
            },
            {
              name: "exposureDivision",
              field: "exposureDivision",
              label: "노출구분",
              style: "width:100px",
              align: "left",
              sortable: true,
            },
            {
              name: "exposureUnit",
              field: "exposureUnit",
              label: "노출단위",
              style: "width:100px",
              align: "left",
              sortable: true,
            },
            {
              name: "exposureResult",
              field: "exposureResult",
              style: "width:100px",
              label: "결과",
              align: "center",
              sortable: true,
            },
            {
              name: "collectionMethod",
              field: "collectionMethod",
              label: "채취방법",
              style: "width:100px",
              align: "left",
              sortable: true,
            },
            {
              name: "analyzeCode",
              field: "analyzeCode",
              label: "분석코드",
              align: "left",
              sortable: true,
            },
            {
              name: "analyzeMethod",
              field: "analyzeMethod",
              label: "분석방법",
              style: "width:100px",
              align: "center",
              sortable: true,
            },
            {
              name: "occurrenceCycleName",
              field: "occurrenceCycleName",
              label: "발생주기명",
              style: "width:100px",
              align: "center",
              sortable: true,
            },
            {
              name: "exposureTime",
              field: "exposureTime",
              label: "폭로시간",
              style: "width:100px",
              align: "center",
              sortable: true,
            },
            {
              name: "measTypeFst",
              field: "measTypeFst",
              label: "측정구분",
              style: "width:100px",
              align: "left",
              sortable: true,
            },
            {
              name: "remark",
              field: "remark",
              label: "비고",
              style: "width:100px",
              align: "left",
              sortable: true,
            },
            {
              name: "beforeExposureStandard",
              field: "beforeExposureStandard",
              label: "보정전노출기준",
              style: "width:100px",
              align: "right",
              sortable: true,
            },
            {
              name: "measUser",
              field: "measUser",
              label: "측정자",
              style: "width:100px",
              align: "center",
              sortable: true,
            },
            {
              name: "integratedType",
              field: "integratedType",
              label: "통합구분",
              style: "width:100px",
              align: "left",
              sortable: true,
            },
            {
              name: "groupType",
              field: "groupType",
              label: "그룹구분",
              style: "width:100px",
              align: "left",
              sortable: true,
            },
            {
              name: "chemGroupCd",
              field: "chemGroupCd",
              label: "취급물질그룹코드",
              style: "width:100px",
              align: "left",
              sortable: true,
            },
            {
              name: "chemGroupOrder",
              field: "chemGroupOrder",
              label: "취급물질그룹순번",
              style: "width:100px",
              align: "left",
              sortable: true,
            },
            {
              name: "measDate",
              field: "measDate",
              label: "측정일자",
              align: "center",
              style: "width:100px",
              sortable: true,
            },
            {
              name: "analysisRequest",
              field: "analysisRequest",
              label: "분석의뢰",
              style: "width:100px",
              align: "center",
              sortable: true,
            },
            {
              name: "groupCd",
              field: "groupCd",
              label: "공정,단위작업장소그룹",
              align: "center",
              style: "width:100px",
              sortable: true,
            },
            {
              name: "measTypeSec",
              field: "measTypeSec",
              label: "측정구분",
              style: "width:100px",
              align: "center",
              sortable: true,
            },
            {
              name: "excludingNoise",
              field: "excludingNoise",
              label: "소음제외키값",
              align: "center",
              style: "width:100px",
              sortable: true,
            },
            {
              name: "exposureStdExceeded",
              field: "exposureStdExceeded",
              label: "노출기준초과",
              style: "width:100px",
              align: "center",
              sortable: true,
            },
            {
              name: "occupationCode",
              field: "occupationCode",
              label: "직종코드",
              align: "center",
              style: "width:100px",
              sortable: true,
            },
            {
              name: "occupationName",
              field: "occupationName",
              label: "직종명",
              align: "center",
              style: "width:100px",
              sortable: true,
            },
            {
              name: "fstTrace",
              field: "fstTrace",
              label: "trace",
              align: "center",
              style: "width:100px",
              sortable: true,
            },
            {
              name: "secTrace",
              field: "secTrace",
              label: "trace",
              style: "width:100px",
              align: "center",
              sortable: true,
            },
            {
              name: "etc",
              field: "etc",
              label: "",
              style: "width:100px",
              align: "center",
              sortable: true,
            },
          ],
        ],
        data: [],
        deptCd: "",
        processCd: "",
        workplace: "",
      },
      changeItem: {
        plant: "",
        process: "",
        vendor: "",
      },
      editable: true,
    };
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
    Object.assign(this.$data, this.$options.data());
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {},
  computed: {
    request() {
      return (
        this.$store.getters.user.deptName +
        " / " +
        this.$store.getters.user.userName +
        " / " +
        this.$comm.getToday()
      );
    },
  },
  methods: {
    init() {
      // role setting
      this.editable = this.$route.meta.editable;
      // url setting
      // code
      // list setting
    },
    acceptData() {
      if (this.excelUploadInfo.data) {
        let dataCntCheck = true;
        let errorDataCheck = false;
        if (
          !this.excelUploadInfo.data[0] ||
          this.excelUploadInfo.data[0].length === 0
        ) {
          dataCntCheck = false;
        }
        if (
          this.$_.findIndex(this.excelUploadInfo.data[0], (item) => {
            return item.error_message;
          }) > -1
        ) {
          errorDataCheck = true;
        }

        if (!dataCntCheck) {
          window.getApp.$emit("ALERT", {
            title: "LBLGUIDE", // 안내
            message:
              "업로드할 데이터가 없는 Sheet가 있습니다.\n데이터 확인 또는 엑셀을 업로드 하였는지 확인바랍니다.",
            type: "warning", // success / info / warning / error
          });
        } else {
          if (errorDataCheck) {
            window.getApp.$emit("CONFIRM", {
              title: "LBLCONFIRM",
              message:
                "에러가 있는 데이터가 존재합니다.\n에러 있는 데이터를 제외한 나머지 데이터를 적용하시겠습니까?",
              // TODO : 필요시 추가하세요.
              type: "info", // success / info / warning / error
              // 확인 callback 함수
              confirmCallback: () => {
                this.$emit("closePopup", this.excelUploadInfo.data[0]);
              },
              // 취소 callback 함수
              cancelCallback: () => {},
            });
          } else {
            this.$emit("closePopup", this.excelUploadInfo.data[0]);
          }
        }
      }
    },
  },
};
</script>
